module.exports = __webpack_public_path__ + "static/media/lp-img-6.bcb8ab69.png";